import React from 'react';
import {
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Input,
	CustomInput,
	Form,
	Row,
	Col,
	Label,
	Button

} from 'reactstrap';
import {getData} from '../services/index';
import { message  } from 'antd';

class Login2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			light_logo:true,
			dark_logo:false,
			open_login_modal:false,
			open_register_modal:false,
			open_otp_modal:false,
			open_forgot_modal:false,
			open_reset_modal:false,
			open_mobile_modal:false,
			provider_id:0,
			mobile : '',
			reset_mobile : '',
			loading: true,
			no_found : 1,
		};	
		this.doLogin = this.doLogin.bind(this);	
		this.onInputChange = this.onInputChange.bind(this);
	}
	
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		this.setState({token : this.props.match.params.text });
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		this.doLogin();
	}
	
	doLogin = () => {
		var app = {
			token : this.props.match.params.text,
		}
		getData('auth/token_login',app).then((result) => {
			if(result.status==400){
				message.config({ top: 50});
				//message.error(result.message);	
			}
			if(result.status==200){
				let responseJson = result;
				if(responseJson.data){
					localStorage.setItem('schoolData',JSON.stringify(responseJson));
					var name = result['data'][0]['user_name'];
					var phone = result['data'][0]['phone'];
					var email = result['data'][0]['email'];
					var user_id = result['data'][0]['user_id'];
					var school_id = result['data'][0]['school_id'];
					var short_name = result['data'][0]['short_name'];
					var type = result['data'][0]['type'];
					var permission = result['data'][0]['permission'];
					this.setState({
						'name': name,
						'phone': phone,
						'email': email,
						'user_id': user_id,
						'school_id': school_id,
						'short_name': short_name,
						'type': type,
						'permission': permission,
					});
					//message.config({ top: 50});
				    //message.success('Successfully Logged In.');	
					var link_ = this.props.match.params.link;
					if(link_ == 'enquiry'){
						setTimeout(() => {
							window.location.href = '/enquiries';
						}, 500);
					}
					else if(link_ == 'student'){
						setTimeout(() => {
							window.location.href = '/children-profiles';
						}, 500);
					}
					else if(link_ == 'school'){
						setTimeout(() => {
							window.location.href = '/my-school';
						}, 500);
					}else{
						setTimeout(() => {
							window.location.href = '/';
						}, 500);
					} 
					
					this.setState({ loading: true });
				}
			}else{
				this.setState({
					'no_found': 0,
				});
			}
		})
		.catch(error => {
			message.config({ top: 50});
			message.error('Invalid Username or Password');	
		});
	}
	
	onInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}
	
	render() {
		return (
			<>
				<div class="content-header row">
            </div>
			{(() => {  
			if (this.state.no_found =='0') {
			return (
				<>
					<div class="no-page-found">
						Sorry No Page Found !! 
					</div>
				</>
			)	
							
			}else{
			return (
				<>
					<div class="validate-loader" style={{display: 'block',
			position: 'relative',
			height: '100%',
			'text-align': 'center',
			'min-height': '500px',
					margin: 'auto auto'}}>
						<img class="rounded-circle" src={`${process.env.PUBLIC_URL}/assets/img/loader.gif`} width="500px" height="500px" alt="Admin" />
					</div>
				</>
			)	
			}
			})()}
            
			</>
		)
	}
}

export default Login2;